export default __webpack_public_path__ + "static/media/04.0edc1a68.jpg";